export const selectProductsList = (state, defaultValue = []) => state.productsRoot.products.list || defaultValue;
export const selectProductsCharacterCorrelationList = (state, defaultValue = []) =>
  state.productsRoot.products.characterCorrelationList || defaultValue;
export const selectProductsIsLoading = (state, defaultValue = false) =>
  state.productsRoot.products.isLoading || defaultValue;
